import React from 'react';
import logo from './logo.svg';
import './App.css';
import { NoteTrainer } from './components/NoteTrainer/NoteTrainer';
import { SheetMusicNoteTrainer } from './components/SheetMusicNoteTrainer/SheetMusicNoteTrainer';

function App() {
  return (
    <div className="App">
      <SheetMusicNoteTrainer />
    </div>
  );
}

export default App;
